import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Navbar scrolled={scrolled} />
      <Hero />
      <VPNService />
      <Features />
      <Contact />
      <About />
      <Footer />
    </div>
  );
}
